<div class="wrapper wrapper-content mtv-directory-page row">
    <div class="ibox mainPartPage"
         [ngStyle]="{width: stripeAccountsService.showDetailedView ? 'calc(100% - 420px)' : ''}">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Stripe'"
                            [placeholder]="null"
                            urlParameterName="accountId"
                            [buildings]="filterItems">
                    </filter>
                </div>
                <stripe-accounts-filter *ngIf="stripeAccountsService.tabId == 'allStripeTransactions'"></stripe-accounts-filter>
                <div *ngIf="!stripeAccountsService.showDetailedView"
                     class="text-right"
                     [ngClass]="{'col-md-3' : stripeAccountsService.tabId == 'allStripeTransactions',
                                 'col-md-5' : stripeAccountsService.tabId == 'allStripePayouts'}"
                     style="line-height: 34px; font-size: 14px;">
                    Available Balance: {{stripeAccountsService.availableBalance | currency}}
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <filters-view></filters-view>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item title="Transactions" [tabId]="'allStripeTransactions'" [ngClass]="{'sk-loading': stripeAccountsService.spinnerShow}">
                    <stripe-transactions-list *ngIf="stripeAccountsService.tabId == 'allStripeTransactions'"></stripe-transactions-list>
                </tab-item>
                <tab-item title="Payouts" [tabId]="'allStripePayouts'" [ngClass]="{'sk-loading': stripeAccountsService.spinnerShow}">
                    <stripe-payouts-list *ngIf="stripeAccountsService.tabId == 'allStripePayouts'"></stripe-payouts-list>
                </tab-item>
                <spinner [spinnerShow]="stripeAccountsService.spinnerShow"></spinner>
            </tabs-wrapper>
        </div>
        <div class="animated animated-directory slideInRight detailed-view dv-sidebar">
            <stripe-accounts-detailed-view *ngIf="stripeAccountsService.showDetailedView"></stripe-accounts-detailed-view>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/stripe-accounts/stripe-accounts.component.html